import SpecProcessor, { type Spec, type Data } from './specProcessor';

export default class NormalSpecProcessor extends SpecProcessor {
  static preprocessing(data: Data, spec: Spec): boolean {
    return NormalSpecProcessor.isEncodingValid(data, spec);
  }
}
